import { GridCellProps } from '@progress/kendo-react-grid';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';

function AlignmentTextCell(props: GridCellProps) {
  const { dataItem } = props;

  const alignmentScore = dataItem['alignmentScore'];
  const changeScore = dataItem['alignmentChangeScore'];
  const backgroundColor = dataItem['alignmentColor1'];
  const textColor = dataItem['alignmentColor2'];
  const label = dataItem['alignmentLabel'];

  if (alignmentScore === undefined) {
    return <td></td>;
  }

  return (
    <td className="cell-sparkline">
      <div
        className="spark-line-box alignment-box alignment-state-cell"
        style={{
          backgroundColor: backgroundColor,
        }}
      >
        <div>
          <p className="spark-line-value alignment-value" style={{ color: textColor }}>
            {label}
          </p>
        </div>
        {changeScore > 0 && (
          <KwelloSvgIcon
            icon={KWELLO_ICON.UP_ARROW}
            className="k-icon k-svg-icon k-button-icon marginRight5 fillGreenColorIcon"
          />
        )}
        {changeScore < 0 && (
          <KwelloSvgIcon
            icon={KWELLO_ICON.DOWN_ARROW}
            className="k-icon k-svg-icon k-button-icon fillRedColorIcon"
          />
        )}
      </div>
    </td>
  );
}

export default AlignmentTextCell;
